<img class="cb-image" alt="checkbox_unchecked" [src]="getImageSrc()" (click)="toggle()">
<label (click)="toggle()" class="cb-text">{{label}}</label>
